import AdminConfigTractorNozzleProfiles from './AdminConfigTractorNozzleProfiles';
export default AdminConfigTractorNozzleProfiles;
